import React from 'react';
import classNames from 'classnames';

import cn from 'layouts/Layout.module.scss';
const { REACT_APP_ENVIRONMENT } = process.env;

export const Warning = () => {
  if (REACT_APP_ENVIRONMENT === 'production') {
    return (
      <div className={classNames(cn.banner, cn.production)}>
        <p>v{process.env.REACT_APP_VERSION}</p>
      </div>
    );
  }
  return (
    <div className={cn.banner}>
      <p>
        v{process.env.REACT_APP_VERSION} All data within this portal is for test purposes and will not affect the
        production environment.
      </p>
    </div>
  );
};
